export const GET_FAQ_STRUCTURE_M = (preview: boolean, limit: number, skip: number) => `
query {
  faqCollection(preview: ${preview}, limit: ${limit}, skip:${skip}) {
    total
    items {
      slug
      question
    }
  }
}
`;
